import { params, const_var } from "../../redux/reducers/reducer.js";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { getBuildingData } from "../index.js";
import { getManufactureDataById } from "../../services/manufacture.services.js";
import { getDealerStateList } from "./manufacture.action.js";
import { loginAuthService, loginService, userDetailsService } from "../../services/auth.service.js";
import { setAuthHeader } from "../../services/http-client.js";
import { renderApp } from "../../index.js";

export const onLoginTextFiledChangeValue = (e, name, keyword, flag) => {
	return (dispatch) => {
		dispatch({
			type: "onLoginTextFiledChangeValue",
			event: e,
			value: name,
			keyword: keyword,
			flagg: flag
		});
	};
};
export const onSubmitLogin = (e) => async (dispatch) => {
	dispatch({
		type: "onSubmitLogin",
		event: e,
		key: "validate"
	});
	if (const_var.checkValidate == false) {
		const_var.showReportLoading = true;
		const_var.checkCaptuareImage = false;
		try {
			const rememberVal = {};
			const formData = {};
			Array.from(e.target.elements).forEach((el) => {
				if (!el.name) return;
				formData[el.name] = el.value;
				rememberVal[el.name] = el.value;
			});
			Object.assign(const_var.post_data, formData);
			const { crmSetting } = const_var;
			const device = /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop";

			const loginApiData = {
				remember_me: formData["remember"] === "on",
				email_or_mobile: formData.username,
				password: formData.password,
				device_id: crypto.randomUUID(),
				browser: getBrowser(),
				device_type: device,
				os: navigator.platform,
				device_label: `${getBrowser()} on ${getOs()}`,
				app: "crm"
			};
			try {
				const response = await loginAuthService(loginApiData);
				const token = response?.auth_data?.access_token;
				if (token) {
					const_var.showLoginScreen = false;
				
					setAuthHeader(token);
				}
			} catch (error) {
				throw new Error("login failed");
			}

			const detailsResponse = await userDetailsService();
			const data = mappedUserDetails(detailsResponse.data);
			const_var.preQuoteError = true;
			const_var.stateChangeflag = "";
			if (crmSetting?.is_zipcode_screen) {
				params.m_s_n = "";
			}
			renderApp();
			dispatch({
				type: "onSubmitLogin",
				event: data,
				data: loginApiData,
				remember: rememberVal,
				key: "login"
			});
			if (crmSetting?.is_zipcode_screen) {
				dispatch(getDealerStateList(false, !!const_var.state_mfg_zipcode, const_var.state_mfg_zipcode));
			} else {
				dispatch(getDealerStateList());
			}
			document.body?.click();
		} catch (error) {
			const message = error?.response?.data?.message || "Login failed";
			dispatch(onSubmitLoginApiErrorhandling(e, message));
		} finally {
			const_var.showReportLoading = false;
		}
	}
};

export const onSubmitLoginApiErrorhandling = (e, message) => {
	return {
		type: "onSubmitLoginApiErrorhandling",
		event: e,
		value: message
	};
};

export const loginRememberMeChange = () => {
	return (dispatch) => {
		dispatch({
			type: "loginRememberMeChange"
		});
	};
};

export const onSubmitLogout = (e) => {
	return (dispatch) => {
		dispatch({
			type: "onSubmitLogout",
			event: e
		});
	};
};
export function logingFromCRM(access_token) {
	return (dispatch) => {
		const decoded = jwt_decode(access_token);
		const eventData = {
			data: {
				userdata: {
					name: decoded.first_name + " " + decoded.last_name,
					api_token: decoded.api_token,
					email: decoded.email,
					first_name: decoded.first_name,
					last_name: decoded.last_name,
					id: decoded.user_id,
					jwt_token: access_token
				}
			}
		};
		const loginApiData = { email: decoded.email, password: const_var.post_data["password"] };
		dispatch({
			type: "onSubmitLogin",
			event: eventData,
			data: loginApiData,
			key: "login"
		});
		if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen) {
			if (const_var.loginSession == false) {
				this.props.getDealerStateList();
			}
		} else {
			dispatch(getDealerStateList());
		}
	};
}
export function iframeEvent(eventData) {
	return (dispatch) => {
		dispatch({
			type: "iframeEvent",
			event: eventData
		});
	};
}
export function resetErrMsg() {
	return (dispatch) => {
		dispatch({
			type: "resetErrMsg"
		});
	};
}
export const getManufactureDetails = (manufactureID, isCallBuildingupdate) => {
	return (dispatch) => {
		getManufactureDataById(const_var.crmSetting.api_token, manufactureID)
			.then((response) => {
				dispatch({ type: "updateManufactureData", payload: response.data });
				if (isCallBuildingupdate) {
					dispatch(getBuildingData(params, "direct"));
				}
			})
			.catch((error) => {
				console.log(error.message);
			});
	};
};

const getBrowser = () => {
	const ua = navigator.userAgent;
	return ua.includes("Chrome") ? "Chrome" : ua.includes("Firefox") ? "Firefox" : ua.includes("Safari") && !ua.includes("Chrome") ? "Safari" : ua.includes("Edge") ? "Edge" : "Unknown";
};
const getOs = () => {
	const ua = navigator.userAgent;
	return ua.includes("Windows") ? "Windows" : ua.includes("Mac") ? "MacOS" : ua.includes("Android") ? "Android" : ua.includes("iPhone") ? "iOS" : "Unknown";
};

export const mappedUserDetails = (details) => {
	return {
		data: {
			is_login: true,
			userdata: {
				api_token: details.api_token,
				company_name: details.company_name,
				email: details.email,
				first_name: details.first_name,
				last_name: details.last_name,
				name: details.name,
				profile_image: details.profile_image,
				jwt_token: details?.jwt_token ?? "",
				lgnby: details?.lgnby ?? "",
				is_password_change_required: details?.is_password_change_required ?? 0,
				user_companies: Array.isArray(details?.user_companies)
					? details.user_companies.map((company) => ({
							company_id: company?.company_id ?? "",
							company_name: company?.company_name ?? "",
							is_selected: company?.is_selected ?? 0,
							sensei_sales_id: company?.sensei_sales_id ?? ""
						}))
					: []
			}
		}
	};
};
